import QualityCheckTable from 'components/QualityCheck';
import { useSelector } from 'react-redux';
import { isCombosEnabled } from 'utils/featureFlags';
import { checkPermission } from 'utils/utils';

export const QualityCheck = () => {
  const selectedCompanyPermission = useSelector(
    (state: any) => state?.userProfile?.data?.permissions
  );
  const isQualityCheckPermission = checkPermission(selectedCompanyPermission, {
    permissionName: 'QualityCheck',
    permission: ['view','viewAll'],
  });
  const isComboQualityCheckPermission = checkPermission(selectedCompanyPermission, {
    permissionName: 'ComboQualityCheck',
    permission: ['view','viewAll'],
  });
  const canAccess =
    isQualityCheckPermission ||
    (isCombosEnabled() && isComboQualityCheckPermission);
  return <div>{canAccess && <QualityCheckTable />}</div>;
};
